import { Autocomplete, TextField } from "@mui/material"
import { translate } from "app/language/service"
import { CAMPAIGN_STATUSES, IStatusFilter } from "campaign/model"
import React from "react"

interface IStatusFilterProps {
  id: string
  label: string
  filters: IStatusFilter[]
  value: CAMPAIGN_STATUSES[]
  sx?: any
  onChange(newValue: CAMPAIGN_STATUSES[]): any
}

export const StatusFilter = React.memo(
  ({ id, label, filters, value, onChange, sx }: IStatusFilterProps): JSX.Element => (
    <Autocomplete
      multiple
      sx={{ ...sx }}
      id={id}
      size="small"
      options={filters}
      getOptionLabel={option => translate(option.labelKey)}
      value={filters.filter(f => value.length > 0 && f.statuses.every(s => value.includes(s)))}
      filterSelectedOptions
      onChange={(_event, newValue) => onChange(newValue.map(v => v.statuses).flat())}
      renderInput={params => <TextField {...params} label={label} />}
    />
  )
)
